import getFileExtension from "./getFileExtension";

const audioExtensions = {
  aac: true,
  wav: true,
};

const hasAudioExtension = (uri: string, fileName: string): boolean => {
  const fileExtensionUri = getFileExtension(uri);
  const fileExtensionFileName = getFileExtension(fileName);

  if (!fileExtensionUri && !fileExtensionFileName) return false;

  return (
    audioExtensions[fileExtensionUri] ||
    audioExtensions[fileExtensionFileName] ||
    false
  );
};

export default hasAudioExtension;
